import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_TOTAL_ZARANDEO } from '../../../../config/tables'

export default function LiquidacionMercaderiaZarandeadaView () {
  return <MuiTable id={TABLA_TOTAL_ZARANDEO} />
}
